// Portal sub-nav for the Quality Signals reader area (non-admin execs, e.g.
// Ravi Joshi): Reports feed ⇄ Constellations (beta). Common Threads and Needs
// review are admin-only and intentionally not shown here. Mirrors SignalsTabs
// but links to the /portal/signals routes and reuses its stylesheet.
//
// The same three pages also sit under the Quality portal's Daily briefs tab
// (/portal/quality-copilot/briefs). There the sub-tabs stay under that tab, so
// the Quality tabs stay on screen with Daily briefs highlighted; they used to
// jump to /portal/signals and lose the Quality portal (fan-out finding 4).

import { Link, useLocation } from 'react-router-dom';
import styles from './SignalsTabs.module.css';

/** Where the Quality portal mounts the briefs pages. */
export const QUALITY_BRIEFS_BASE = '/portal/quality-copilot/briefs';
/** The standalone Quality Signals reader area. */
export const PORTAL_SIGNALS_BASE = '/portal/signals';

/** The base the sub-tabs link under, from where the reader is now. */
export function signalsTabsBase(pathname: string): string {
  return pathname === QUALITY_BRIEFS_BASE || pathname.startsWith(`${QUALITY_BRIEFS_BASE}/`)
    ? QUALITY_BRIEFS_BASE
    : PORTAL_SIGNALS_BASE;
}

export function PortalSignalsTabs() {
  const { pathname } = useLocation();
  const base = signalsTabsBase(pathname);
  const onConstellations = pathname.startsWith(`${base}/constellations`);
  const onDigest = pathname.startsWith(`${base}/digest`);
  const onReports = !onConstellations && !onDigest;
  return (
    <nav className={styles.tabs}>
      <Link
        to={base}
        className={`${styles.tab} ${onReports ? styles.active : ''}`}
      >
        Reports
      </Link>
      <Link
        to={`${base}/constellations`}
        className={`${styles.tab} ${onConstellations ? styles.active : ''}`}
      >
        Constellations <span className={styles.beta}>beta</span>
      </Link>
      <Link
        to={`${base}/digest`}
        className={`${styles.tab} ${onDigest ? styles.active : ''}`}
      >
        My watches
      </Link>
    </nav>
  );
}
